module.exports = __webpack_public_path__ + "img/yiliaojiankang.ff38ec0d.png";